import { render } from "./FetchingError.vue?vue&type=template&id=fe8ee70a&ts=true"
import script from "./FetchingError.vue?vue&type=script&lang=ts"
export * from "./FetchingError.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__